import * as React from "react";
import { useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box, Button, Typography, Alert } from "@mui/material";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import useMediaQuery from "@mui/material/useMediaQuery";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { LoadingSvg } from "../../../../utils/SvgIcons";
import Tooltip from "@mui/material/Tooltip";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import IconButton from "@mui/material/IconButton";
import DialogData from "./DialogData";
import Divider from "@mui/material/Divider";

import EditIcon from "@mui/icons-material/Edit";
import ModeEditIcon from "@mui/icons-material/ModeEdit";

// import DisableCode from "./DisableCode";
// import ShowDetailsCode from "./ShowDetailsCode";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(name, data) {
  return { name, data };
}
const RecivedAccountInfoData = [
  {
    _id: "6310f1bd4fac2dffcd02f87c",
    firstName: "firstName",
    lastName: "lastName",
    mobileNumber: 123456789,
    identificationCardNumber: "identificationCardNumber",
    // identificationCard: "urlllllidentificationCard",
    situation: "pending",
  },
];

// دیتاهای مورد نیاز و اسم نمایشی آنها را تعین میکند
const neededAccountInfoData = {
  firstName: "نام",
  lastName: "نام خانوادگی",
  mobileNumber: "شماره همراه",
  identificationCardNumber: "شماره کارت ملی",
  // identificationCard: "اسکن کارت ملی",
  situation: "وضعیت تایید",
};
// دیتاهای مورد نیاز و اسم نمایشی آنها را تعین میکند
const neededBankCardsData = {
  bankName: "نام بانک",
  bankCartNumber: "شماره کارت بانکی",
  bankAccountNumber: "شماره حساب بانکی",
  bankShaba: "شماره شبا",
  situation: "وضعیت حساب",
};

export default function UserAccountingInfo(props) {
  const {
    userAccountingInfo,
    bankCardsData,
    setNumberPageAndPerPage,
    controlAlert,
  } = props;
  // اگر سایز صفحه از 600 پیکسل کوچکتر شود مقدار ترو برمیگرداند
  const detectSize600px = useMediaQuery("(min-width:600px)");
  const [openDialogContent, setOpenDialogContent] = React.useState(false);
  const [dialogTitle, setDialogTitle] = React.useState("");
  const [dialogContentData, setDialogContentData] = React.useState("");
  const [statusCodeState, setStatusCodeState] = React.useState({});

  const RecivedAccountInfoData = [userAccountingInfo];
  const RecivedBankCardsData = bankCardsData["docs"];
  // [
  //   {
  //     _id: "6310f85ed2c9f98740ed5a6b",
  //     userInfoId: "6310f1bd4fac2dffcd02f87c",
  //     bankName: "bank2",
  //     bankCartNumber: 2,
  //     bankAccountNumber: 2,
  //     bankShaba: 2,
  //     situation: "در انتظار تایید",
  //   },
  //   {
  //     _id: "6310f88cd2c9f98740ed5a71",
  //     userInfoId: "6310f1bd4fac2dffcd02f87c",
  //     bankName: "bank1",
  //     bankCartNumber: 1,
  //     bankAccountNumber: 1,
  //     bankShaba: 1,
  //     situation: "در انتظار تایید",
  //   },
  // ];

  // هر مجموعه از دیتا را برای هر جدول درون یک المنت آرایه از listOfTable میریزد
  let listOfTable =
    RecivedAccountInfoData.length > 0
      ? RecivedAccountInfoData.map((el, index) => {
        const rowOfTableData = [];
        rowOfTableData[0] = el;
        for (const property in el) {
          // دیتاهایی که در neededAccountInfoData گفته ایم نیاز داریم را جدا می کند
          if (neededAccountInfoData[property]) {
            if (el[property] == "llmmt-Loading") {
              rowOfTableData.push(
                createData(neededAccountInfoData[property], {
                  name: property,
                  data: <LoadingSvg />,
                })
              );
            } else if (el[property] == "llmmt-NoData") {
              rowOfTableData.push(
                createData(neededAccountInfoData[property], {
                  name: property,
                  data: (
                    <Tooltip title="اطلاعاتی وارد نشده است">
                      <Typography>-{"------"}</Typography>
                    </Tooltip>
                  ),
                })
              );
            } else if (el[property] == "llmmt-errorLoading") {
              rowOfTableData.push(
                createData(neededAccountInfoData[property], {
                  name: property,
                  data: (
                    <Tooltip title="مشکل در بار گزاری اطلاعات،لطفا دوباره تلاش کنید">
                      <SyncProblemIcon color="error" />
                    </Tooltip>
                  ),
                })
              );
            } else {
              if (property == "birthDay") {
                const date = new DateObject({
                  date: el[property],
                  calendar: persian,
                  locale: persian_fa,
                });
                rowOfTableData.push(
                  createData(neededAccountInfoData[property], {
                    name: property,
                    data: date.format(),
                  })
                );
              } else
                rowOfTableData.push(
                  createData(neededAccountInfoData[property], {
                    name: property,
                    data: el[property],
                  })
                );
            }
          }
        }
        return rowOfTableData;
      })
      : [];
  let allBankCardStatus = {};
  // هر مجموعه از دیتا را برای هر جدول درون یک المنت آرایه از listOfTable میریزد
  let listOfBankCardTable =
    RecivedBankCardsData.length > 0
      ? RecivedBankCardsData.map((el, index) => {
        const rowOfTableData = [];
        rowOfTableData[0] = el;
        for (const property in el) {
          // دیتاهایی که در neededBankCardsData گفته ایم نیاز داریم را جدا می کند
          if (neededBankCardsData[property]) {
            // دیتاهایی که  بصورت تاریخ هستند - باید خودمان مشخص کنیم-. را تبدیل به تاریخ شمسی میکند
            if (
              property == "createdAt" ||
              property == "endingDate" ||
              property == "startingDate"
            ) {
              const date = new DateObject({
                date: el[property],
                calendar: persian,
                locale: persian_fa,
              });
              rowOfTableData.push(
                createData(neededBankCardsData[property], {
                  name: property,
                  data: date.format(),
                })
              );
            } else if (property == "status") {
              // console.log("elelelel", el._id, el.status);
              allBankCardStatus[el._id] = el.status;
              rowOfTableData.push(
                createData(neededBankCardsData[property], {
                  name: property,
                  data: el[property],
                })
              );
            } else
              rowOfTableData.push(
                createData(neededBankCardsData[property], {
                  name: property,
                  data: el[property],
                })
              );
          }
        }
        return rowOfTableData;
      })
      : [];

  const handleOpenDialogContent = () => {
    setOpenDialogContent(true);
  };
  const handleCloseDialogContent = () => {
    setOpenDialogContent(false);
  };

  //  فانکشنی برای نشان دادن پاپ آپ وابسته به کلیک بر روی دکمه های مختلف در جدول
  const setDialog = (type, dataContent) => {
    if (type == "editInfo") {
      setDialogTitle("ویرایش اطلاعات");
      handleOpenDialogContent();
      setDialogContentData(
        <>
          <Divider />
          <Typography sx={{ m: 1 }}>
            لطفا برای ثبت و ویرایش اطلاعات خود بر روی گزینه ویرایش مشخصات من
            کلیک کنید
          </Typography>
        </>
      );
    } else if (type == "editBankAccount") {
      setDialogTitle("ویرایش اطلاعات کارت");
      handleOpenDialogContent();
      setDialogContentData(
        <>
          <Divider />
          <Typography sx={{ m: 1 }}>
            به زودی امکان ویرایش کارت بانکی فراهم خواهد شد{" "}
          </Typography>
        </>
      );
    }
  };

  // اطلاعات هر سطر را بر میگرداند و در صورت نیاز قبل از برگرداندن تغیراتی روی دیتا انجام می دهیم
  const showRowData = (index, data, oneRow) => {
    const { name, data: content } = data;
    if (content == "llmmt-loading") {
      return <StyledTableCell align="left">در حال بارگزاری</StyledTableCell>;
    } else if (content == "llmmt-errorLoading") {
      return <StyledTableCell align="left">در حال بارگزاری</StyledTableCell>;
    } else if (name == "situation") {
      // "awaitingConfirmation",
      // "confirmed",
      // "rejected",
      // "edited",
      switch (content) {
        case "awaitingConfirmation":
          return <StyledTableCell align="left">منتظر تایید</StyledTableCell>;
        case "confirmed":
          return <StyledTableCell align="left">تایید شده</StyledTableCell>;
        case "rejected":
          return <StyledTableCell align="left">عدم تایید</StyledTableCell>;
        case "edited":
          return (
            <StyledTableCell align="left">
              ویرایش شده(منتظر تایید)
            </StyledTableCell>
          );
        default:
          return <StyledTableCell align="left">نامشخص</StyledTableCell>;
      }
    }
    // else if (
    //   name == "mobileNumber" &&
    //   !isNaN(content) &&
    //   !isNaN(listOfTable[0][0]["areaCodeMobileNumber"])
    // ) {
    //   // console.log("44545", name,content);
    //   // return <StyledTableCell align="left">{listOfTable[0][0]["areaCodeMobileNumber"]}</StyledTableCell>;

    //   return (
    //     <StyledTableCell align="left">{`${content} - ${listOfTable[0][0]["areaCodeMobileNumber"]}+`}</StyledTableCell>
    //   );
    // }
    else {
      return <StyledTableCell align="left">{content}</StyledTableCell>;
    }
  };
  const showRowBankCardData = (index, data, oneRow) => {
    const { name, data: content } = data;
    if (name == "situation") {
      switch (content) {
        case "awaitingConfirmation":
          return <StyledTableCell align="left">منتظر تایید</StyledTableCell>;
        case "needCorrection":
          return <StyledTableCell align="left">نیاز به تایید</StyledTableCell>;
        case "confirmed":
          return <StyledTableCell align="left">تایید شده</StyledTableCell>;
        case "rejected":
          return <StyledTableCell align="left">عدم تایید</StyledTableCell>;
        default:
          return <StyledTableCell align="left">نامشخص</StyledTableCell>;
      }
    } else {
      return <StyledTableCell align="left">{content}</StyledTableCell>;
    }
  };

  return (
    <>
      <DialogData
        openDialogContent={openDialogContent}
        handleCloseDialogContent={handleCloseDialogContent}
        dialogTitle={dialogTitle}
      >
        {dialogContentData}
      </DialogData>
      <Box>
        <Box
          sx={{
            backgroundColor: "#0f014a",
            width: "100%",
            borderRadius: "10px",
            py: 1,
            px: 2,
            mb: 1,
          }}
        >
          اطلاعات حساب:
        </Box>
        {listOfTable.map((oneRow, index) => (
          <TableContainer
            key={`MainTable-${index}`}
            component={Paper}
            sx={{ mb: 1 }}
          >
            <Table sx={{ minWidth: 10 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    sx={{ width: detectSize600px ? "25%" : "50%" }}
                  ></StyledTableCell>
                  <StyledTableCell
                    sx={{ width: detectSize600px ? "75%" : "50%" }}
                    align="left"
                  ></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {oneRow.map((row, indexrow) =>
                  indexrow == 0 ? (
                    <StyledTableRow key={`row-${indexrow}`}>
                      <StyledTableCell sx={{ m: 0, p: 0 }}>
                        <IconButton
                          key={`row-${indexrow}`}
                          sx={{ ml: 2 }}
                          aria-label="edit"
                          color="warning"
                          onClick={(e) => {
                            setDialog("editInfo", index);
                          }}
                        >
                          <ModeEditIcon />
                        </IconButton>
                      </StyledTableCell>
                      <StyledTableCell align="left"></StyledTableCell>
                    </StyledTableRow>
                  ) : (
                    <StyledTableRow key={`row-${indexrow}`}>
                      <StyledTableCell component="th" scope="row">
                        "{row.name}"
                      </StyledTableCell>
                      {showRowData(index, row.data, oneRow)}
                    </StyledTableRow>
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        ))}
        <hr />
        <Box
          sx={{
            backgroundColor: "#0f014a",
            width: "100%",
            borderRadius: "10px",
            py: 1,
            px: 2,
            mb: 1,
          }}
        >
          شماره کارت های بانکی:
        </Box>
        <Collapse in={controlAlert.open}>
          <Alert severity={controlAlert.severity} sx={{ mb: 2 }}>
            {controlAlert.message}
          </Alert>
        </Collapse>
        <Stack sx={{ display: controlAlert.SkeletonDisplay }} spacing={1}>
          <Skeleton />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
        </Stack>
        {listOfBankCardTable.map((oneRow, index) => (
          <TableContainer
            key={`MainTable2-${index}`}
            component={Paper}
            sx={{ mb: 1 }}
          >
            <Table sx={{ minWidth: 10 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    sx={{ width: detectSize600px ? "25%" : "50%" }}
                  >{`کارت ${index + 1}`}</StyledTableCell>
                  <StyledTableCell
                    sx={{ width: detectSize600px ? "75%" : "50%" }}
                    align="left"
                  ></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {oneRow.map((row, indexrow) =>
                  indexrow == 0 ? (
                    <StyledTableRow key={`row-${indexrow}`}>
                      <StyledTableCell sx={{ m: 0, p: 0 }}>
                        <IconButton
                          key={`row-${indexrow}`}
                          sx={{ ml: 2 }}
                          aria-label="edit"
                          color="warning"
                          onClick={(e) => {
                            setDialog("editBankAccount", index);
                          }}
                        >
                          <ModeEditIcon />
                        </IconButton>
                      </StyledTableCell>
                      <StyledTableCell align="left"></StyledTableCell>
                    </StyledTableRow>
                  ) : (
                    <StyledTableRow key={`row2-${indexrow}`}>
                      <StyledTableCell component="th" scope="row">
                        {row.name}
                      </StyledTableCell>
                      {showRowBankCardData(index, row.data, oneRow)}
                    </StyledTableRow>
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        ))}
      </Box>
    </>
  );
}
